import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { CartJobs } from "./Cart";
import { CheckoutJobs } from "./Checkout";
export var Jobs = function Jobs(repository, networkManager) {
  _classCallCheck(this, Jobs);

  this.cart = new CartJobs();
  this.checkout = new CheckoutJobs(repository, networkManager);
};